import { render, staticRenderFns } from "./ContentItemCard.vue?vue&type=template&id=2b1c0377&scoped=true"
import script from "./ContentItemCard.vue?vue&type=script&lang=js"
export * from "./ContentItemCard.vue?vue&type=script&lang=js"
import style0 from "./ContentItemCard.vue?vue&type=style&index=0&id=2b1c0377&prod&scoped=true&lang=scss"
import style1 from "./ContentItemCard.vue?vue&type=style&index=1&id=2b1c0377&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1c0377",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CustomLink: require('/Users/daiyu/Desktop/work-code/bantervideo/components/CustomLink/index.vue').default})
